import React, { useState, useEffect } from 'react';
import { axios } from '../../utils/apiUtils';
import { useTranslation } from 'react-i18next';
import { Redirect, useParams } from 'react-router-dom';

import Experience from '../../components/experience';
import { getAxiosConfig } from '../../utils/apiUtils';
import "react-multi-carousel/lib/styles.css";
import commonStyles from '../../common';
import { Col, Container, ListGroup, Modal, Row } from 'react-bootstrap';

import seasonIcon from '../../assets/images/stations.svg'
import { isAllowedToPlayVideo } from '../../utils/authUtils';

const styles = {
  layout: {
    paddingLeft: '42px',
    paddingRight: '42px',
  },
  header: {
    backgroundColor: '#f0f2f5',
    marginTop: '32px',
    marginBottom: '32px',
  },
  title: {
    ...commonStyles.chungungoH1,
    color: 'black',
    margin: '32px',
  },
  subtitle: {
    ...commonStyles.chungungoH2,
    color: 'black',
    margin: '32px',
  }
};

const Season = (props) => {
  let { id } = useParams();
  const { t, i18n } = useTranslation();
  const [season, setSeason] = useState({});
  const [experiences, setExperiences] = useState([]);
  const [goToExperience, setGoToExperience] = useState();
  const [goToSubscription, setGoToSubscription] = useState(false);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);

  const refreshSeason = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/${id}`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((seasonResponse) => {
        setSeason(seasonResponse.data);
      })
      .catch(console.error);
  };

  const refreshExperiences = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/${id}/experiences`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((experiencesResponse) => {
        setExperiences(experiencesResponse.data);
      })
      .catch(console.error);
  };

  useEffect(
    () => {
      refreshSeason();
      refreshExperiences();
    },
    []
  );

  if (goToExperience) {
    return (<Redirect to={`/experiences/${goToExperience}`} push />)
  }

  if (goToSubscription) {
    return <Redirect to="/account/subscribe/confirm" push/>
  }

  return (
    <>
      <section className="hero pt-4 pb-4 mb-5"
        style={{
          backgroundImage: `url("${season.cover}")`
        }}
      >
        <Modal
          show={showSubscribeModal}
          onHide={evt => setShowSubscribeModal(false)}
        >
          <div className="modal-content">
            <div className="modal-body">
              <h5 className="modal-title mb-3" style={{ color: '#692700' }}>
                {t('subscription.modal_onlysubscribers.title')}
              </h5>
              <p>
                {t('subscription.modal_onlysubscribers.message')}
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-link" onClick={evt => setShowSubscribeModal(false)}>
                {t('subscription.modal_onlysubscribers.close')}
              </button>
              <button type="button" className="btn btn-outline-success" onClick={evt => setGoToSubscription(true)}>
                {t('subscription.modal_onlysubscribers.subscribe')}
              </button>
            </div>
          </div>
        </Modal>
        <div className="container">
          <div className="row">
            <div className="d-flex align-content-between flex-wrap">
              <div className="texto-principal">
                <div className="col-12 align-self-start caj-Titulo-Principal pt-3">
                  <span className="icon-headline-1 station-icon"
                    style={{
                      backgroundImage: `url(${seasonIcon})`
                    }}
                  ></span>
                  <h1 className="headline-1">{season.name}</h1>
                </div>
                <p className="hero__parrafo col-8">
                  {season.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="actividad">
        <div className="container">
          <div className="row">
            <div className="tituloSecundario col-12 mb-4">
              <h2 className="titular2 pr-4">{t('season.title')}</h2>
            </div>
            {experiences.map((experience) => (
              <Experience experience={experience} onClick={() => isAllowedToPlayVideo() || experience.isPublic ? setGoToExperience(experience._id) : setShowSubscribeModal(true)} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Season;
